import { useEffect, useState } from 'react';
import Contact from './Contact';
import EmergenyContact from './EmergenyContact';
import Identity from './Identity';
import ResponsibleParty from './ResponsibleParty';
import Statistics from './Statistics';
import { post } from '../../Auths/AuthToken';
import setUiMessage from '../../../Utilities/Tostify';

function PatientProfile({ patientId }) {
  const [allData, setAllData] = useState(null);
  const [reload, setReload] = useState(false);
  const handleReload = () => setReload(!reload);

  useEffect(() => {
    (async () => {
      try {
        const response = await post('api/patient/Patient/patientProfileView', {
          patientId: patientId,
        });
        if (response?.status === 200) {
          setAllData(response?.data);
        }
      } catch (e) {
        setUiMessage('err', e.message);
      }
    })();
  }, [patientId, reload]);

  return (
    <div className="demo-main-con">
      <div className="c-mid-bdy-hdr clear-top10">
        <span className="widget-hdr-title bold clear-top">Demographics:</span>
      </div>
      <div className="demo-main-con-bdy">
        <Identity
          data={allData?.identityDetailArr}
          patientId={patientId}
          reload={handleReload}
        />
        <Contact
          data={allData?.contactDetailArr}
          patientId={patientId}
          reload={handleReload}
        />
        <EmergenyContact
          data={allData?.emergencyContactArr}
          patientId={patientId}
          reload={handleReload}
        />
        <ResponsibleParty
          data={allData?.responsiblePartyArr}
          patientId={patientId}
          reload={handleReload}
        />
        <Statistics
          data={allData?.statisticsArr}
          patientId={patientId}
          reload={handleReload}
        />
      </div>
    </div>
  );
}

export default PatientProfile;
